package dev.lingvo.shared.screenshots.frames

import dev.lingvo.shared.DeviceClass
import dev.lingvo.shared.screenshots.doc.FrameFinish
import dev.lingvo.shared.screenshots.doc.FrameKind
import dev.lingvo.shared.screenshots.geom.Rect
import dev.lingvo.shared.screenshots.render.DeviceShadow
import dev.lingvo.shared.screenshots.render.ImageHandle
import dev.lingvo.shared.screenshots.render.Path
import dev.lingvo.shared.screenshots.render.Surface

/** Explicit paths keep frame paint and editor hit geometry in agreement. */
data class FrameLayout(
    val outer: Rect, val outerRadius: Double, val screen: Rect, val screenRadius: Double,
    val bodyPath: Path, val screenPath: Path, val cutoutPath: Path?, val buttonPaths: List<Path>, val extras: List<Path>,
)

/** Frame effects are explicit so thumbnails and exports use the same appearance. */
data class FramePaintOptions(
    val finish: FrameFinish, val paletteBg: String, val homeIndicator: Boolean,
    val glare: Boolean, val shadow: DeviceShadow?,
)

/** Device geometry is shared by rendering, layout and editor snapping. */
interface DeviceFrames {
    /** Fits body and buttons inside [box], centred; the screen keeps [screenAspect] (h / w) exactly. */
    fun layout(kind: FrameKind, box: Rect, screenAspect: Double, screenRadius: Double? = null): FrameLayout
    /** SPEC-B 5.2 draw order; [screen] is drawn COVER inside the screen clip; null leaves the screen black. */
    fun paint(surface: Surface, kind: FrameKind, layout: FrameLayout, options: FramePaintOptions, screen: ImageHandle?)
    /** Offers a sensible initial frame for the store's device class. */
    fun defaultFor(device: DeviceClass): FrameKind
    /** Restricts the picker to compatible device silhouettes. */
    fun offeredFor(device: DeviceClass): List<FrameKind>
}
